import React from 'react';

const DownloadIcon = () => (
  <svg className="download-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 17V3"/>
    <path d="m6 11 6 6 6-6"/>
    <path d="M19 21H5"/>
  </svg>
);

export default DownloadIcon;
